import { render, staticRenderFns } from "./RequireInput.vue?vue&type=template&id=0497602a&lang=pug"
import script from "./RequireInput.vue?vue&type=script&lang=ts"
export * from "./RequireInput.vue?vue&type=script&lang=ts"
import style0 from "./RequireInput.vue?vue&type=style&index=0&id=0497602a&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports